import { truckerProfileApiService } from 'config/truckerProfileService';
import { ISearchedTruckerProps } from 'context/reducers/searchTruckers.type';

export const getSearchTrucker = (freightId: string, term: string): Promise<ISearchedTruckerProps> =>
  truckerProfileApiService.get(`/trucker/search?query=${term}&freightId=${freightId}`);
